import service1 from "@/utils/service1";
import service from "@/utils/service";

// 获取基础数据表
export const qksFeeList = (data) => service1.post("/qks/fee/list", data);
// 获取公告列表
export const noticeList = (data) => service.get("/notice/list", data);
